module.exports = __webpack_public_path__ + "static/media/0022.6f7cc48e.jpg";